import { USER } from "./types";

import ActionHelper from "../helpers/ActionHelper";

/*export const getUser = (id) => dispatch => {

    return ActionHelper.requestServer('GET', '/user/' + id, null, USER.USER_GET_REQUEST, USER.USER_GET_SUCCESS, USER.USER_GET_FAIL, dispatch);
}

export const updateUser = (id, form) => dispatch => {

    return ActionHelper.requestServer('PUT', '/user/' + id, form, USER.USER_UPDATE_REQUEST, USER.USER_UPDATE_SUCCESS, USER.USER_UPDATE_FAIL, dispatch);

}*/

export const updatePassword = (id, form) => (dispatch) => {
  return ActionHelper.requestServer(
    "PUT",
    "/user/" + id + "/password",
    form,
    USER.USER_PASSWORD_UPDATE_REQUEST,
    USER.USER_PASSWORD_UPDATE_SUCCESS,
    USER.USER_PASSWORD_UPDATE_FAIL,
    dispatch,
  );
};

export const createPassword = (token, form) => (dispatch) => {
  return ActionHelper.requestServer(
    "POST",
    "/user/" + token + "/password",
    form,
    USER.USER_CREATE_PASSWORD_REQUEST,
    USER.USER_CREATE_PASSWORD_SUCCESS,
    USER.USER_CREATE_PASSWORD_FAIL,
    dispatch,
  );
};

export const sendPasswordRecoveryEmail = (form) => (dispatch) => {
  return ActionHelper.requestServer(
    "POST",
    "/user/send-password-recovery-email",
    form,
    USER.USER_SEND_PASSWORD_RECOVERY_EMAIL_REQUEST,
    USER.USER_SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS,
    USER.USER_SEND_PASSWORD_RECOVERY_EMAIL_FAIL,
    dispatch,
  );
};

export const getAppSettings = () => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    "/app/settings",
    null,
    USER.USER_GET_APP_SETTINGS_REQUEST,
    USER.USER_GET_APP_SETTINGS_SUCCESS,
    USER.USER_GET_APP_SETTINGS_FAIL,
    dispatch,
  );
};

export const updateAppSettings = (form) => (dispatch) => {
  return ActionHelper.requestServer(
    "PUT",
    "/app/settings",
    form,
    USER.USER_UPDATE_APP_SETTINGS_REQUEST,
    USER.USER_UPDATE_APP_SETTINGS_SUCCESS,
    USER.USER_UPDATE_APP_SETTINGS_FAIL,
    dispatch,
  );
};



// WEBPACK FOOTER //
// ./src/actions/userActions.js